import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseText from '@/components/BaseText.vue';
import RebateDetailsQuery from '@/plugins/graphql/queries/v2/store_add_ons/rebate-details.gql';
import { RebateDetailsModel } from '@/helpers/entities/models/RebateDetailsModel';
import { RebateStatus } from '@/helpers/entities/enums/v2/RebateStatus';
let VoucherRebateDetails = class VoucherRebateDetails extends Vue {
    constructor() {
        super(...arguments);
        this.receiptDialog = false;
        this.downloadOnProcess = false;
        this.receiptDocumentDialogHeader = '';
        this.receiptDocumentUrl = '';
        this.receiptDocumentFileName = '';
    }
    get voucherStatus() {
        return this.rebate.status === RebateStatus.Approved
            ? 'Voucher code is valid'
            : this.rebate.status;
    }
    openDocumentDialog(header, documentUrl, fileName) {
        this.receiptDialog = !this.receiptDialog;
        this.receiptDocumentDialogHeader = header;
        this.receiptDocumentUrl = documentUrl;
        this.receiptDocumentFileName = fileName;
    }
    downloadReceipt(imageUrl, filename) {
        this.downloadOnProcess = !this.downloadOnProcess;
        fetch(imageUrl).then((image) => {
            return image.blob().then((imageFile) => {
                const a = document.createElement('a');
                a.href = URL.createObjectURL(imageFile);
                a.setAttribute('download', filename);
                a.click();
                this.downloadOnProcess = false;
            });
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], VoucherRebateDetails.prototype, "rebateUuid", void 0);
VoucherRebateDetails = __decorate([
    Component({
        apollo: {
            rebate: {
                query: RebateDetailsQuery,
                variables() {
                    return {
                        rebateUuid: this.rebateUuid,
                    };
                },
                update(data) {
                    return new RebateDetailsModel(data.superMiniAppRebate);
                },
            },
        },
        components: {
            BaseText,
        },
    })
], VoucherRebateDetails);
export default VoucherRebateDetails;
